// extracted by mini-css-extract-plugin
export default {"page":"Fla-z","cartModal":"Gla-z","checkout":"Hla-z","placeholder":"Ila-z","account":"Jla-z"};